import axios from "axios";
import Cookies from 'universal-cookie';
import {baseUrl} from "@configs/requestConfig";
import initialHeaders from "./initialheaders";
import handleError from "./errorHandler";


/**
 * Makes a DELETE request to the server.
 *
 * @async
 * @param {string} url - The URL to make the request to.
 * @param {object} [headers] - The headers to include in the request.
 * @param {boolean} [locale=false] - Whether to use the locale cookie value or the language cookie value.
 * @returns {Promise<object>} A promise that resolves with the response data.
 */
const deleteRequest = async (url, headers = initialHeaders, locale = false) => {

    try {
        const cookies = new Cookies();
        headers.locale = cookies.get(locale ? "locale" : "language");

        const requestConfig = {headers: {...initialHeaders(), ...headers}};
        const response = await axios.delete(`${baseUrl}${url}`, requestConfig);

        return response.data;
    } catch (err) {
        handleError(err)
        throw err;
    }
};

export default deleteRequest;
